<div class="flex items-center justify-between gap-4 mb-4">
  <h1>Dane organizacji</h1>
</div>

@if (organization()) {
  <div class="flex flex-col gap-6">
    <app-admin-panel-user-organization-identification-section
      [fields]="identificationSectionFields()"
    ></app-admin-panel-user-organization-identification-section>

    <app-admin-panel-user-organization-address-and-bank-account-section
      [fields]="addressAndBankAccountSectionFields()"
    ></app-admin-panel-user-organization-address-and-bank-account-section>

    <app-admin-panel-user-organization-other-information-section
      [fields]="otherInformationSectionFields()"
    ></app-admin-panel-user-organization-other-information-section>

    <app-admin-panel-user-organization-related-persons-section
      [userDetails]="userDetails()!"
      [organizationId]="organizationId()"
    ></app-admin-panel-user-organization-related-persons-section>

    <div class="flex justify-end gap-3">
      <p-button
        label="Pobierz dane organizacji"
        styleClass="customInfoButton outlined"
        (onClick)="downloadOrganizationData()"
      />
      <p-button
        label="Zamknij"
        styleClass="customInfoButton outlined"
        (onClick)="goBack()"
      />
    </div>
  </div>
}
